<template>
    <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center" >
        <div class="flex flex-col"  >
            <h5 class="mb-1 text-primary" style="font-weight: 600;">{{ name }}</h5>
        </div>
    </div>
</template>

<script>
export default {
    name: "DisciplineName",
    props:{
        name:{type:Text}
    }
};
</script>

<style scoped>

</style>
